<template>
  <div class="container-card-download">
    <unicom-icone class="icone-file-download" nome="file" :tamanho="20" />
    <div>
      <div>{{ nomeArquivo }}</div>
    </div>
    <div class="container-circular">
      <unicom-icone class="icone-circular" nome="check" :tamanho="14" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nomeArquivo: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.container-card-download {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  min-width: 312px;
  height: 20px;
  padding: 20px 24px;
  display: -webkit-box;
  flex-flow: wrap column;
  justify-content: center;
  align-content: flex-start;

  .icone-file-download {
    color: #00995d;
    padding-right: 16px;
  }

  .container-circular {
    margin-left: auto;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #1daa7d;
    color: white;
    position: relative;

    .icone-circular {
      padding: 5px;
    }
  }
}
</style>
